import { v4 as uuidv4 } from "uuid"

import { sendPosPayment } from "services"
import socketConnection from "./socketConnection"

let requestId
let resolve
let acknowledge

const onPosTerminalPaymentResult = (jsonMessage) => {
  const message = JSON.parse(jsonMessage)

  const event = message.key

  if (event === "posTerminalAcknowledge") {
    const value = message.value

    if (value.requestId !== requestId) return

    acknowledge()

    return
  }

  if (event === "posTerminalPaymentResult") {
    const value = message.value

    if (value.requestId !== requestId) return

    resolve(value.success ? "success" : "unsuccess")

    resolve = undefined

    return
  }
}

const send = (
  amount,
  terminalName,
  onRequestSent = () => { },
  onRequestAcknowledge = () => { }
) =>
  new Promise(async (r) => {
    if (!!resolve) resolve("canceled")

    requestId = uuidv4()

    resolve = r

    acknowledge = onRequestAcknowledge

    try {
      await sendPosPayment({
        amount,
        terminalName,
        requestId
      })

      onRequestSent()

      const socket = socketConnection.getSocket()

      socket.removeListener("basicEmit", onPosTerminalPaymentResult)

      socket.on("basicEmit", onPosTerminalPaymentResult)
    } catch (err) {
      resolve("requestFailed")
    }
  })

const cancel = () => {
  if (!!resolve) resolve("canceled")
}

const posTerminalRequest = {
  send,
  cancel
}

export default posTerminalRequest